export const WORK_HOURS_CONFIG = {
  startHour: 6,
  endHour: 22,
  allowedTypes: [0, 2],
  get warningMessage() {
    return `⚠️ Atenció: Hores extraordinàries!\n` +
           `Hi ha imputació fora d'horari (${this.startHour}:00 i ${this.endHour}:00) amb un tipus hora "Laboral" o "Desplaçament".\n` +
           `Si són hores extraordinàries, assegura\'t que el tipus sigui "Extra" o "Especial".`;
  }
};

// Cache DOM elements for better performance
let $workOrderForms = null;
let $totalHoursCalc = null;

function cacheForms() {
  $workOrderForms = $('.work-order-item-form');
  $totalHoursCalc = $('.total-hores-calc._js');
}

// Debounce validation for rapid changes
let validationTimeout;
function scheduleValidation() {
  clearTimeout(validationTimeout);
  validationTimeout = setTimeout(() => {
    set_total_time();
  }, 300);
}

export default function addWorkOrder() {
  // Initial cache
  cacheForms();

  // Use event delegation for dynamic elements
  $(document)
    .on('click', '.add-work-order', function() {
      add_new_input_row('work-order', 'work_order[work_order_items_attributes]');
    })
    .on('click', '.add-work-center', function() {
      add_new_input_row('work-center', 'client[work_centers_attributes]');
    })
    .on('change', '.time_work_order', scheduleValidation)
    .on('click', '.remove-work-center', function() {
      const imgElement = $(this);
      const parentDiv = imgElement.closest('[id^="work-center-item-form_"]');
      const parentDivId = parentDiv.attr('id');
      const elementId = parentDivId.split('_').pop();

      parentDiv.remove();
      const hiddenElement = $('#client_work_centers_attributes_' + elementId + '_id');
      hiddenElement.after(hiddenElement.clone());

      const newHiddenElement = $('#client_work_centers_attributes_' + elementId + '_id').last();
      newHiddenElement.attr('id', 'client_work_centers_attributes_' + elementId + '_deleted')
                     .attr('name', 'client[work_centers_attributes][' + elementId + '][deleted]')
                     .attr('value', '1');
    });

  // Initial calculations
  set_total_time();
}

function set_total_time() {
  if (!$totalHoursCalc || !$totalHoursCalc.length) return;

  let totalMins = 0;

  // Use a simple for loop instead of reduce for better performance
  for (let i = 0; i < $workOrderForms.length; i++) {
    totalMins += get_mins($workOrderForms[i]);
  }

  const hours = Math.floor(totalMins / 60);
  const minutes = totalMins % 60;
  $totalHoursCalc.text(`${hours}h ${('0' + minutes).slice(-2)}m`);
}

// Helper function to parse combined time string "HH:MM" into hours and minutes
function parseCombinedTime(timeString) {
  if (!timeString) return { hours: 0, minutes: 0 };

  const [hours, minutes] = timeString.split(':').map(Number);
  return { hours: hours || 0, minutes: minutes || 0 };
}

function get_mins(parent_node) {
  const $parent = $(parent_node);

  // Get the combined time values
  const entranceTime = $parent.find('.entrance_time_combined_js').val();
  const departureTime = $parent.find('.departure_time_combined_js').val();

  // Check if both required fields are filled
  const filled = entranceTime && departureTime;

  if (filled) {
    const e_time = parseCombinedTime(entranceTime);
    const d_time = parseCombinedTime(departureTime);

    // Convert to minutes since midnight
    const entranceTotal = e_time.hours * 60 + e_time.minutes;
    let departureTotal = d_time.hours * 60 + d_time.minutes;

    // Handle overnight case
    if (departureTotal <= entranceTotal) {
      departureTotal += 24 * 60;
    }

    return departureTotal - entranceTotal;
  }
  return 0;
}

function add_new_input_row(target_klass, html_name) {
  // Count existing forms of the same type to determine next ID
  const formSets = {
    'work-center': 'work-center-item-form',
    'work-order': 'work-order-item-form'
  };
  const existingForms = $("." + formSets[target_klass]);
  const id = existingForms.length;
  const $form = $(`.${target_klass}-item-form`).last();
  const $newForm = $form.clone();

  // Define field sets for different target classes
  const fieldSets = {
    'work-center': ['name', 'distance'],
    'work-order': ['entrance_time_combined', 'departure_time_combined', 'description', 'tipus_hora']
  };

  // Get the appropriate fields for the target class, default to empty array
  const klasses = fieldSets[target_klass] || [];

  klasses.forEach(val => {
    const $input = $newForm.find(`.${val}_js`);
    $input.val('')
          .removeClass('is-invalid')
          .attr('name', `${html_name}[${id}][${val}]`);

    // Set default for select
    if (val === 'tipus_hora') {
      $input.val($(`.${val}_js`).first().val());
    }

    // For select elements, we need to trigger change to update UI
    if ($input.is('select')) {
      $input.trigger('change');
    }
  });

  // Insert new form with animation
  $newForm.insertAfter($form).hide().show(600);

  // Refresh cache
  cacheForms();
}

function validate_work_hours() {
  let showWarning = false;

  $('.work-order-item').each(function() {
    const $item = $(this);

    // Get times from data attributes instead of form inputs
    const entranceHour = parseInt($item.data('entrance-hour')) || 0;
    const departureHour = parseInt($item.data('departure-hour')) || 0;
    const hourTypeText = $item.data('tipus-hora'); // Get the text value

    // Convert tipus_hora text to numeric value
    let hourType = 0;
    if (hourTypeText === 'extra') {
      hourType = 1;
    } else if (hourTypeText === 'desplaçament') {
      hourType = 2;
    } else if (hourTypeText === 'special') {
      hourType = 2;
    }

    // Check if outside working hours AND invalid type
    const isOutsideHours = (entranceHour >= WORK_HOURS_CONFIG.endHour ||
                          entranceHour < WORK_HOURS_CONFIG.startHour) ||
                         (departureHour > WORK_HOURS_CONFIG.endHour ||
                          departureHour < WORK_HOURS_CONFIG.startHour);

    if (isOutsideHours && WORK_HOURS_CONFIG.allowedTypes.includes(hourType)) {
      showWarning = true;
      $item.addClass('border border-danger');
      $item.find('.tipus_hora_js').addClass('text-danger');
    }
  });

  if (showWarning) {
    alert(WORK_HOURS_CONFIG.warningMessage);
  }
}

// Call this when the page loads
$(document).ready(function() {
  validate_work_hours();
});

// Ensure only one checkbox is selected at a time
$(document).on('change', '.mutually-exclusive-checkbox', function() {
  if (this.checked) {
    $('.mutually-exclusive-checkbox').not(this).prop('checked', false);
  }
});
